import { render } from "./Male.vue?vue&type=template&id=ffff9b84&scoped=true"
import script from "./Male.vue?vue&type=script&lang=js"
export * from "./Male.vue?vue&type=script&lang=js"

import "./Male.vue?vue&type=style&index=0&id=ffff9b84&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffff9b84"]])

export default __exports__